import React, {Component} from 'react';
import SuggestedTime, {suggestedTimeQuery} from './suggested_time';
import ForecastQueryRenderer from '../../../../../ForecastQueryRenderer';

class SuggestedTimeRenderer extends Component {
	render() {
		const {addTimeSuggestion, inputParent, input, date, personId, dateString, timeSuggestionsEnabled, usePopup, selectedValue, onOptionBlur} = this.props;

		return (
			<ForecastQueryRenderer
				key="query-render-suggestedTime"
				componentName="suggested_time"
				query={suggestedTimeQuery}
				variables={{personId: personId || '', dateString: dateString || ''}}
				render={(relayProps, retry) => {
					return (
						<SuggestedTime
							{...relayProps}
							retry={retry}
							timeSuggestionsEnabled={timeSuggestionsEnabled}
							addTimeSuggestion={addTimeSuggestion}
							inputParent={inputParent}
							selectedValue={selectedValue}
							input={input}
							date={date}
							dateString={dateString}
							personId={personId}
							usePopup={usePopup}
							onOptionBlur={onOptionBlur}
						/>
					);
				}}
			/>
		);
	}
}

SuggestedTimeRenderer.propTypes = {};

export default SuggestedTimeRenderer;
